// Author lidongxu
// Date 2023-08-17 14:47:33

class EmDictType {
constructor({
        id = null,
        dictName = '',
        dictType = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.dictName = dictName;
    this.dictType = dictType;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new EmDictType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emDictType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dictName',
        label: 'label.em.admin.emDictType.grid.dictName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dictType',
        label: 'label.em.admin.emDictType.grid.dictType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'status',
        label: 'label.em.admin.emDictType.grid.status',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '0', text: '启用' },
                            { value: '1', text: '停用' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emDictType.grid.remark',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    dictNameFilter : '',
    dictTypeFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'dictNameFilter',
        label: 'label.em.admin.emDictType.filter.dictName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dictTypeFilter',
        label: 'label.em.admin.emDictType.filter.dictType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.admin.emDictType.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '启用' },
                { value: '1', text: '停用' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
         key: 'dictType',
         label: 'label.em.admin.emDictData.filter.dictType',
         sortable: true,
         disabled: false,
         form: {
         type: 'input',
          modalMultiSelectedType: 'string'
            }
        },
        {
        key: 'dictName',
        label: 'label.em.admin.emDictType.entity.dictName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'status',
        label: 'label.em.admin.emDictType.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '0', text: '启用' },
                { value: '1', text: '停用' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emDictType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]
const editEntityConfigs = [
    {
        key: 'id',
        label: 'label.em.admin.emDictType.grid.id',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dictName',
        label: 'label.em.admin.emDictType.entity.dictName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'status',
        label: 'label.em.admin.emDictType.entity.status',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
            ,options: [
                { value: '0', text: '启用' },
                { value: '1', text: '停用' }
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.em.admin.emDictType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {EmDictType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs, editEntityConfigs
, filterConfigs


}
